import { useMe } from '@/lib/useMe'

// Whether Moments shows in Modern style: the owner's Moments style switch, the same for everyone.
export const useModernMoments = () => useMe().data?.momentsStyle === 'modern'
